/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Roles_TitleInputs */

const da_privacy_roles_title = /** @type {(inputs: Privacy_Roles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To roller: dine oplysninger og elevernes`)
};

/** @type {(inputs: Privacy_Roles_TitleInputs) => LocalizedString} */
const en_privacy_roles_title = da_privacy_roles_title;

/**

* @param {Privacy_Roles_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_roles_title = /** @type {((inputs?: Privacy_Roles_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Roles_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_roles_title(inputs)
	return /** @type {LocalizedString} */ ("To roller: dine oplysninger og elevernes")
});